import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var InfoCircleOutline = function InfoCircleOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM11.9893 21.1387C7.05859 21.1387 3.11621 17.1748 3.11621 12.2441C3.11621 7.31348 7.05859 3.36035 11.9785 3.36035C16.9092 3.36035 20.873 7.31348 20.8838 12.2441C20.8945 17.1748 16.9199 21.1387 11.9893 21.1387ZM11.9248 8.61328C12.752 8.61328 13.3965 7.95801 13.3965 7.15234C13.3965 6.31445 12.752 5.66992 11.9248 5.66992C11.1191 5.66992 10.4639 6.31445 10.4639 7.15234C10.4639 7.95801 11.1191 8.61328 11.9248 8.61328ZM10.0879 18.0879H14.4492C14.9326 18.0879 15.3193 17.7441 15.3193 17.25C15.3193 16.7881 14.9326 16.4229 14.4492 16.4229H13.2568V11.3525C13.2568 10.708 12.9346 10.2783 12.333 10.2783H10.2812C9.79785 10.2783 9.42188 10.6436 9.42188 11.1055C9.42188 11.5996 9.79785 11.9541 10.2812 11.9541H11.377V16.4229H10.0879C9.61523 16.4229 9.22852 16.7881 9.22852 17.25C9.22852 17.7441 9.61523 18.0879 10.0879 18.0879Z"
  })));
};

InfoCircleOutline.displayName = 'InfoCircleOutline';
export default InfoCircleOutline;